import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';

@Component({
    selector: 'cpq-toastr-success-template',
    templateUrl: './cpq-toastr-template.component.html',
    styleUrl: './cpq-toastr-template.component.scss',
    standalone: false
})
export class CpqToastrTemplateComponent {
  
  constructor(
    public snackBarRef: MatSnackBarRef<CpqToastrTemplateComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public data: { message: string; action: string, type: string }
  ){}

  public dismiss(){
    this.snackBarRef.dismiss();
  }
}
